var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulbOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 1000,
    viewBox: "0 0 120 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11024_44913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4286 923.103C43.416 930.332 48.0099 936.734 54.7809 938.923C61.5514 941.113 68.9356 938.585 73.0277 932.676C77.1192 926.767 76.9742 918.841 72.6693 913.092L67.3784 898.737L52.0505 898.737L46.7591 913.092C44.598 915.966 43.4277 919.485 43.4286 923.103V923.103Z",
    fill: "#CCD8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 928.897C52 929.37 51.6162 929.754 51.1429 929.754V929.754C50.6695 929.754 50.2857 929.37 50.2857 928.897L50.2857 928.856C50.2857 928.382 50.6695 927.998 51.1429 927.998V927.998C51.6162 927.998 52 928.382 52 928.856L52 928.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8572 925.386C54.8572 925.859 54.4734 926.243 54 926.243V926.243C53.5266 926.243 53.1429 925.859 53.1429 925.386L53.1429 924.759C53.1429 924.285 53.5266 923.902 54 923.902V923.902C54.4734 923.902 54.8572 924.285 54.8572 924.759L54.8572 925.386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0253 898.178H69.4033L76 920.931H43.4286L50.0253 898.178Z",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1511 897.03C70.1511 898.135 69.2557 899.03 68.1511 899.03L51.7144 899.03C50.6098 899.03 49.7144 898.135 49.7144 897.03L49.7144 886.83C49.7144 885.725 50.6098 884.83 51.7144 884.83L68.1511 884.83C69.2557 884.83 70.1511 885.725 70.1511 886.83L70.1511 897.03Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7449 881.398L65.1205 881.398C67.0304 881.398 68.579 883.033 68.579 885.05L51.2864 885.05C51.2864 883.033 52.8345 881.398 54.7449 881.398Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2857 896.653L60.8572 896.653L60.8572 894.93L70.2857 894.93L70.2857 896.653Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2857 892.346L49.7144 892.346L49.7144 888.901L70.2857 888.901L70.2857 892.346Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7563 901.022C58.8134 900.378 59.3531 899.884 60 899.884V899.884C60.6469 899.884 61.1867 900.378 61.2438 901.022L62.6642 917.048C62.7679 918.218 61.8463 919.225 60.6721 919.225H59.328C58.1537 919.225 57.2321 918.218 57.3358 917.048L58.7563 901.022Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4658 901.144C63.4454 900.454 63.9989 899.884 64.6887 899.884V899.884C65.282 899.884 65.7898 900.31 65.8933 900.894L68.7264 916.876C68.9436 918.101 68.0014 919.225 66.7571 919.225H65.9418C64.8602 919.225 63.9746 918.365 63.9427 917.284L63.4658 901.144Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5792 900.903C67.4998 900.366 67.9161 899.884 68.4591 899.884V899.884C68.8622 899.884 69.215 900.155 69.3186 900.545L73.6678 916.901C73.9798 918.074 73.0954 919.225 71.8813 919.225V919.225C70.9647 919.225 70.1865 918.553 70.0526 917.646L67.5792 900.903Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1067 900.894C54.2103 900.31 54.7181 899.884 55.3114 899.884V899.884C56.0012 899.884 56.5546 900.454 56.5342 901.144L56.0574 917.284C56.0254 918.365 55.1398 919.225 54.0583 919.225H53.2429C51.9987 919.225 51.0564 918.101 51.2736 916.876L54.1067 900.894Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1068 900.557C50.2123 900.16 50.5713 899.884 50.9816 899.884V899.884C51.5236 899.884 51.9441 900.357 51.8804 900.895L49.9229 917.459C49.8039 918.466 48.9505 919.225 47.9367 919.225H47.7441C46.4307 919.225 45.4738 917.98 45.8113 916.711L50.1068 900.557Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    width: 4,
    height: 881,
    fill: "#F7F7F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11024_44913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 1000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbOff);
export default __webpack_public_path__ + "static/media/bulb_off.d3d1545ee5415d1cf895a8bbe71ce17b.svg";
export { ForwardRef as ReactComponent };